import React from 'react';
import { CommonIconProps } from './Icon';

const ShieldIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.13574V19.6683C12.0411 19.6922 12.0821 19.7162 12.1231 19.7402C13.1489 19.2318 14.4373 18.4785 15.5554 17.4969C17.0518 16.1829 18 14.6845 18 12.9997V6.38574L12 4.13574Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.0001 6.38601L6 13C6 13 6 13 6 13C6.00001 14.6844 6.86555 16.0108 8.29533 17.2261C9.37362 18.1426 10.5343 18.8169 11.6745 19.4792C11.8245 19.5663 11.9742 19.6532 12.1232 19.7404C13.149 19.2321 14.4375 18.4788 15.5555 17.4971C17.0519 16.1832 18.0001 14.6847 18.0001 13V6.386L12.0001 4.136L6.0001 6.38601ZM12.0001 2L4.00012 5L4 13C4 17.3361 8.01103 19.6666 10.8154 21.2961C11.2449 21.5456 11.646 21.7787 12.0001 22C14.3334 21 20.0001 18 20.0001 13V5L12.0001 2Z"
      fill={color}
    />
  </>
);

export default ShieldIcon;
